export const INBURSA_COBRAND_CODES: readonly string[] = [
  'SFIDBT', // CA       — Débito Cuenta Inbursa-Aeroméxico  (340281674)
  'SFIASC', // TITANIUM — Inbursa-Aeroméxico Ascend          (340281682)
  'SFIELE', // PLATINUM — Inbursa-Aeroméxico Elevate         (340281690)
  'SFIHRZ', // GOLD/SILVER — Inbursa-Aeroméxico Horizon      (340281708 / 340281716)
] as const;

/**
 * Hint para el fallback descriptivo (uppercase).
 * Cubre cualquier `cobrandCode` que contenga literalmente "INBURSA".
 */
export const INBURSA_COBRAND_HINT = 'INBURSA' as const;

/** Whitelist precomputada en uppercase para comparación O(n) sin alocaciones extra. */
const INBURSA_WHITELIST_UPPER = INBURSA_COBRAND_CODES.map((c) => c.toUpperCase());

/**
 * Retorna `true` si el `code` recibido representa a un cobrand INBURSA.
 *
 * @param code valor de `passenger.benefits.cobrandCode` (puede ser undefined).
 */
export function isInbursaCobrand(code?: string | null): boolean {
  if (!code) {
    return false;
  }
  const normalized = code.toString().trim().toUpperCase();
  const viaWhitelist = INBURSA_WHITELIST_UPPER.includes(normalized);
  const viaFallback = !viaWhitelist && normalized.includes(INBURSA_COBRAND_HINT);
  return viaWhitelist || viaFallback;
}
